<template>
  <div class="d-flex justify-start align-center small-gap p-2 my-2 cart_course_item">
    <div>
      <v-badge :content="item.quantite_souhaite" inline></v-badge>
    </div>
    <div>
      <div class="text-body-1">{{ item.nom }}</div>
    </div>
    <div class="justify-self-end text-body font-weight-bold">
      <span v-if="item.current_price">{{ item.current_price }}€</span>
      <span v-else>Gratuit</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"],
};
</script>

<style lang="scss" scoped>
</style>